import { render } from "./THREECanvas.vue?vue&type=template&id=c7b2d8bc"
import script from "./THREECanvas.vue?vue&type=script&lang=js"
export * from "./THREECanvas.vue?vue&type=script&lang=js"

import "./THREECanvas.vue?vue&type=style&index=0&id=c7b2d8bc&lang=css"

import exportComponent from "/Users/joschabruning/Documents/MA/sem03/shelfgenerator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__